/* =========================================================
   RABESSA AYUBI — welcome popup

   Standalone. Delete this file and the section and the shop is
   unchanged; nothing else depends on it.

   The rules it obeys:
     · it asks once, politely, and remembers the answer
     · someone who signs up is never asked again
     · Escape closes it, focus is trapped while it is open, and
       focus goes back to where it was when it closes
     · under prefers-reduced-motion it fades instead of springing
     · it never appears at all if this file fails to load
   ========================================================= */
(function () {
  "use strict";

  var root = document.querySelector("[data-wpop]");
  if (!root) return;

  var KEY = "rabessa_welcome";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var panel   = root.querySelector("[data-wpop-panel]");
  var scrim   = root.querySelector("[data-wpop-scrim]");
  var askEl   = root.querySelector("[data-wpop-ask]");
  var doneEl  = root.querySelector("[data-wpop-done]");
  var posted  = root.getAttribute("data-posted") === "true";
  var lastFocus = null;
  var open = false;

  /* ---------- remembering the answer ---------- */
  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || "null"); }
    catch (e) { return null; }   // private mode, blocked storage — treat as unseen
  }
  function write(state) {
    try { window.localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function subscribed() {
    var s = read();
    return !!(s && s.subscribed);
  }
  function snoozed() {
    var s = read();
    if (!s || !s.dismissedAt) return false;
    var days = parseInt(root.getAttribute("data-remind-days") || "14", 10);
    return (Date.now() - s.dismissedAt) < days * 864e5;
  }

  /* ---------- opening and closing ---------- */
  function show() {
    if (open) return;
    open = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    // reflow so the transition runs from the closed state
    void root.offsetWidth;
    root.classList.add("is-open");
    document.body.classList.add("wpop-locked");

    var target = doneEl.hidden ? root.querySelector("#wpop-email")
                               : root.querySelector("[data-wpop-copy], .btn");
    if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }

    document.addEventListener("keydown", onKey, true);
    try {
      document.dispatchEvent(new CustomEvent("rabessa:popup_shown"));
      if (window.dataLayer) window.dataLayer.push({ event: "rabessa_popup_shown" });
    } catch (e) {}
  }

  function hide(reason) {
    if (!open) return;
    open = false;
    root.classList.remove("is-open");
    document.body.classList.remove("wpop-locked");
    document.removeEventListener("keydown", onKey, true);

    var ms = reduce ? 0 : 260;
    window.setTimeout(function () { if (!open) root.hidden = true; }, ms);

    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }

    if (reason === "dismiss") {
      var s = read() || {};
      s.dismissedAt = Date.now();
      write(s);
      try {
        document.dispatchEvent(new CustomEvent("rabessa:popup_dismissed"));
        if (window.dataLayer) window.dataLayer.push({ event: "rabessa_popup_dismissed" });
      } catch (e) {}
    }
  }

  /* ---------- keyboard ---------- */
  function focusable() {
    return Array.prototype.slice.call(panel.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }
  function onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); hide("dismiss"); return; }
    if (e.key !== "Tab") return;
    var items = focusable();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- copy the code ---------- */
  var copyBtn = root.querySelector("[data-wpop-copy]");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      var code = (root.querySelector("[data-wpop-code]") || {}).textContent || "";
      code = code.trim();
      var label = copyBtn.textContent;
      function done() {
        copyBtn.textContent = copyBtn.getAttribute("data-copied") || "Copied";
        window.setTimeout(function () { copyBtn.textContent = label; }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else { fallback(); }

      function fallback() {
        // older Safari and any browser that refuses the async API
        var ta = document.createElement("textarea");
        ta.value = code;
        ta.setAttribute("readonly", "");
        ta.style.cssText = "position:fixed;top:-1000px;opacity:0";
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand("copy"); done(); } catch (e) {}
        ta.remove();
      }
    });
  }

  /* ---------- wiring ---------- */
  Array.prototype.forEach.call(root.querySelectorAll("[data-wpop-close]"), function (b) {
    b.addEventListener("click", function () { hide("dismiss"); });
  });
  if (scrim) scrim.addEventListener("click", function () { hide("dismiss"); });

  /* ---------- decide whether to ask ---------- */
  if (posted) {
    // Shopify has bounced back after a successful signup: show the code at once
    // and make sure this visitor is never asked again.
    write({ subscribed: true, at: Date.now() });
    askEl.hidden = true;
    doneEl.hidden = false;
    show();
    try {
      document.dispatchEvent(new CustomEvent("rabessa:popup_subscribed"));
      if (window.dataLayer) window.dataLayer.push({ event: "rabessa_popup_subscribed" });
    } catch (e) {}
    return;
  }

  if (subscribed() || snoozed()) return;

  var delay = parseInt(root.getAttribute("data-delay") || "3000", 10);
  window.setTimeout(function () {
    // Don't interrupt someone who is mid-task in the cart drawer.
    var drawer = document.querySelector(".drawer.is-open");
    if (drawer) return;
    show();
  }, delay);
})();
